<div class=" create-dialog-box scrollable-dialog" >
 
    <div class=" title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0" >{{data?.data?.title}}</h4>
        <!-- <button
            class="close-btn bg-transparent p-0 border-none"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button> -->
    </div>

    <div class="box">
        <div class="p-20" [innerHTML]="data?.data?.description "></div>
    </div>

    <div class="title d-flex align-items-center justify-content-center">
        <div class= "">
            <button
            mat-flat-button
            type="button"
            class="tagus fw-semibold d-block ms-5 d-flex justify-content-end"
            [matBadge]=""
            matBadgePosition="after" 
            matBadgeColor="accent"
            (click)="dismissThisNotice()"
            >
                    {{ "Submit" | translate }}

            </button>
        </div>
    </div>
    
</div>


